module.exports = __webpack_public_path__ + "static/media/keynote.c9398312.svg";